'use strict';

// Vue
import Vue from 'vue';

// Services
import { arrayLoop } from 'services/array';

// API
import {
  getEmailLogs,
  getEmailActivity,
} from 'api/emails';

// State
const state = {
  emails: {
    next: ``,
    count: 0,
    results: {},
  },
  emailActivities: {
    next: ``,
    count: 0,
    results: {},
  },
};

// Getters
const getters = {
  emailLogs: state => state.emails,
  emailLogsById: state => id => state.emails.results[id] || {},
  emailLogsLength: (state, getters) => Object.keys(getters.emailLogs.results).length,
  emailLogsTotal: state => state.emails.count,
  emailActivity: state => state.emailActivities,
  emailActivityById: state => id => state.emailActivities.results[id] || {},
  emailActivityLength: (state, getters) => Object.keys(getters.emailActivity.results).length,
  emailActivityTotal: state => state.emailActivities.count, 
};

// Mutations
const mutations = {
  CLEAR_EMAIL_LOGS (state) {
    Vue.set(state.emails, `results`, {});

    state.emails.next = ``;
    state.emails.count = 0;
  },
  UPDATE_EMAIL_LOGS (state, { results, next, count }) {
    arrayLoop(results, (i, result) => Vue.set(state.emails.results, result.id, result));

    state.emails.next = next;
    state.emails.count = count;
  },
  RESET_EMAIL_LOGS_ON_LOGOUT (state) {
    Vue.set(state, `emails`, {
      next: ``,
      count: 0,
      results: {},
    });
  },
  CLEAR_EMAIL_ACTIVITY (state) {
    Vue.set(state.emailActivities, `results`, {});

    state.emailActivities.next = ``;
    state.emailActivities.count = 0;
  },
  UPDATE_EMAIL_ACTIVITY (state, { results, next, count }) {
    arrayLoop(results, (i, result) => Vue.set(state.emailActivities.results, result.id, result));

    state.emailActivities.next = next;
    state.emailActivities.count = count;
  },
  RESET_EMAIL_ACTIVITY_ON_LOGOUT (state) {
    Vue.set(state, `emailActivities`, {
      next: ``,
      count: 0,
      results: {},
    });
  },
};


// Actions
const actions = {
  getEmailLogs({ commit }, url = false) {
    if (!url) {
      commit(`CLEAR_EMAIL_LOGS`);
    }

    return new Promise((resolve, reject) => {
      getEmailLogs(url)
        .then(res => {
          const data = res.data || {};
          const results = data.results || [];

          if (results.length) {
            commit(`UPDATE_EMAIL_LOGS`, data);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getEmailActivity({ commit }, id, url = false) {
    if (!url) {
      commit(`CLEAR_EMAIL_ACTIVITY`);
    }

    return new Promise((resolve, reject) => {
      getEmailActivity(id, url)
        .then(res => {
          const data = res.data || {};
          const results = data.results || [];

          if (results.length) {
            commit(`UPDATE_EMAIL_ACTIVITY`, data);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  resetOnLogout({ commit }) {
    commit(`RESET_EMAIL_LOGS_ON_LOGOUT`);
    commit(`RESET_EMAIL_ACTIVITY_ON_LOGOUT`);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/emails.js